





















































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, error, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'

const metaInfo = () => ({
  title: $.t('view.persist.userPersist.title'),
})

@Component({
  metaInfo,
})
export default class UserPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  responsavel = new Responsavel()
  confirmPassword = ''

  async mounted() {
    if (this.id) await this.responsavel.getAssociado(this.id)
    $.await.done('getAssociado')
  }

  async persist() {
    // await this.responsavel.endereco.populateLatLng()

    await this.responsavel.validate()
    await this.responsavel.endereco.validate()

    if (this.responsavel.senha && this.confirmPassword && this.responsavel.senha !== this.confirmPassword) {
      error('system.error.passwordsDontMatch')
      return
    }

    await this.responsavel.persistAssociado()
    successAndPush('system.success.persist', '/manage/responsavel/list')
  }
}
